import getConfig from 'next/config';

export const {
  LOCAL_BFPS,
  CLUSTER,
  ENV,
  SERVICE_NAME,
  RIG_DEPLOYMENT_TYPE,
  SIMULATE_ISLAND,
  site_captcha_key,
  sentry_dsn: sentryDsn,
  abeagle_host: abeagleHost
} = getConfig().publicRuntimeConfig;
